var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=c5t5wnxp6mvabdrpn7wm4zt2zu/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span class=\"dropdown-current-value-not-in-options\">"
    + container.escapeExpression(container.lambda(container.strict(depth0, "name", {"start":{"line":1,"column":54},"end":{"line":1,"column":58}} ), depth0))
    + "</span>\n";
},"useData":true});